import SmartHomePanel2 from '@elem/compPage/SmartHomePanel2/Launch';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';

export default function Page({ SEO }: any) {
    const { useLang, useEffect, useRouter, useState } = useGlobal();
    const [theme, setTheme] = useState('black');
    const { t } = useLang('smart_home_panel_2');
    const router = useRouter();
    const { locale } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!['us', 'ca', 'mx'].includes(locale)) {
            return router.push('/404');
        }
    }, []);

    return (
        <>
            <SEO title={t('launch.seo_title')} description={t('launch.seo_desc')} />
            <SEOlinksA list={['us', 'ca', 'br']} locale={locale} pathname="smart-home-panel-2" />
            <GtmPageLoad />
            <PageLayout hideToTop className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <SmartHomePanel2 theme={theme} />
            </PageLayout>
            <style global jsx>
                {`
                    .ef-top-offers {
                        display: none;
                    }
                `}
            </style>
        </>
    );
}
